module.exports = __webpack_public_path__ + "static/enterpriseApps-99ff2b549d8e2e4c438f8cfa2326257d.png";